import React, { ReactNode } from 'react'
import { FormikErrors } from 'formik'
import { Info } from '@components/icons'
import { FormError, Tooltip } from 'components/atoms'
import styles from './FormField.module.sass'

export interface Props {
  id: string
  label?: string
  size?: 'md'
  layout?: 'sm' | 'md' | 'lg' | 'full'
  space?: 'none' | 'md'
  color?: '' | 'white'
  status?: '' | 'success' | 'error'
  helper?: {
    id: string
    label: string
    pos?: 'top' | 'right' | 'bottom' | 'left'
  }
  errorMessage?: string | string[] | FormikErrors<any> | FormikErrors<any>[]
  className?: string
  required?: boolean
  children?: ReactNode
}

const FormField = (props: Props) => {
  const {
    id = '',
    label = undefined,
    size = 'md',
    layout = 'md',
    space = 'md',
    color = '',
    status = '',
    helper = undefined,
    errorMessage = '',
    className = '',
    required = false,
    children = null,
  } = props

  const classNames = `${styles.root}
    ${size ? styles[`root--${size}`] : ''}
    ${size ? styles[`root--layout-${layout}`] : ''}
    ${space ? styles[`root--space-${space}`] : ''}
    ${color ? styles[`root--${color}`] : ''}
    ${status ? styles[`root--${status}`] : ''} 
    ${required ? styles[`root--required`] : ''}
    ${className ? className : ''}`

  return (
    <div className={classNames}>
      {!!label && (
        <div className={styles.head}>
          <label className={styles.label} htmlFor={id}>
            {label}
          </label>
          {!!helper && (
            <span className={styles.helper}>
              <Tooltip {...helper}>
                <span className={styles.helperIcon}>
                  <Info />
                </span>
              </Tooltip>
            </span>
          )}
        </div>
      )}
      <div className={styles.children}>{children}</div>
      <FormError
        id={`${id}_mainerror`}
        message={errorMessage as string}
        visible={status === 'error'}
      />
    </div>
  )
}

export default FormField
